import React from "react";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import PMManagers from "./pages/PMManagers";
import OGTPS_LB from "./pages/OGT-ps-lb";
import OGTB2C_LB from "./pages/OGT-b2c-lb";
import LOLout from "./pages/LOLout";

import CatalystHub from "./pages/CatalystHub";
import CatalystSugarCubes from "./pages/CatalystSugarCubes";
import CatalystAgenda from "./pages/CatalystAgenda";
import CatalystDay2 from "./pages/CatalystDay2";

import ILT from "./pages/IGT-ILT";
import EduHub from "./pages/EduHub";
import Benchmark from "./pages/Benchmark";
import Utopia from "./pages/Utopia";
import SheTalks from "./pages/SheTalks";
import GlobalCarnival from "./pages/GlobalCarnival";
import WEevolve from "./pages/WEvolve";
import BenchmarkMain from "./pages/BenchmarkMain";
import BenchmarkBeta from "./pages/BenchmarkBeta";
import KickStart from "./pages/KickStart";
import IM from "./pages/IM";

import ReactGA from "react-ga";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

ReactGA.initialize("UA-167115659-2", { siteSpeedSampleRate: 100 });

export default function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route path="/pm-managers">
            <PMManagers />
          </Route>

          <Route path="/ogt-ps-lb">
            <OGTPS_LB />
          </Route>

          <Route path="/ogt-b2c-lb">
            <OGTB2C_LB />
          </Route>

          <Route path="/lolout">
            <LOLout />
          </Route>

          <Route exact path="/catalyst">
            <CatalystHub />
          </Route>

          <Route path="/catalyst/sugarcubes">
            <CatalystSugarCubes />
          </Route>

          <Route path="/catalyst/agenda">
            <CatalystAgenda />
          </Route>

          <Route path="/catalyst/day2">
            <CatalystDay2 />
          </Route>

          <Route path="/ilt">
            <ILT />
          </Route>

          <Route path="/eduhub">
            <EduHub />
          </Route>

          <Route path="/benchmark-oc">
            <Benchmark />
          </Route>

          <Route path="/utopia">
            <Utopia />
          </Route>

          <Route path="/shetalks">
            <SheTalks />
          </Route>

          <Route path="/globalcarnival">
            <GlobalCarnival />
          </Route>

          <Route path="/wevolve">
            <WEevolve />
          </Route>

          <Route path="/benchmark">
            <BenchmarkMain />
          </Route>

          <Route path="/benchmark-beta">
            <BenchmarkBeta />
          </Route>

          <Route path="/kickstart">
            <KickStart />
          </Route>

          <Route path="/im">
            <IM />
          </Route>

          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>

      {/* ADD THIS BACK AFTER BENCHMARK */}
      {/* <Footer /> */}
    </>
  );
}
